module.exports = __webpack_public_path__ + "build/img/fir_s.ecd58238.png";